import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SovosNavigation, SovosProvider } from "mosaic-react";
import { Home, SovosLogo as Sovos } from "mosaic-react-icons";

function NavBar() {
  const navigate = useNavigate();

  const linksData = [
    {
      key: "inicio",
      icon: Home,
      action: () => {
        navigate("/");
      },
      label: "inicio",
    },
  ];

  const [selectedLink, setSelectedLink] = useState("inicio");

  const addSelectStateAction = React.useCallback((link) => {
    const { action, id, label, nestedLinks } = link;

    const newAction = () => {
      action();
      setSelectedLink(id ?? label);
    };

    return {
      ...link,
      action: nestedLinks ? null : newAction,
      nestedLinks: nestedLinks ? nestedLinks.map(addSelectStateAction) : null,
    };
  }, []);

  // making a copy of the linksData and updating the `action` callback. We're going through this so that we can reuse the data but still access state
  const links = React.useMemo(
    () => linksData.map(addSelectStateAction),
    [addSelectStateAction]
  );
  return (
    <>
      <SovosProvider>
        <SovosNavigation
          FooterProps={{
            showSettingsButton: false,
            userMenuItems: [],
            userName: "Portal Ose",
          }}
          links={links}
          selectedLink={selectedLink}
          product={{
            icon: Sovos,
            id: "0",
            name: "Portal OSE",
          }}
        />
      </SovosProvider>
    </>
  );
}

export default NavBar;
